import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
  } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import { Info } from "lucide-react"

export const TooltipModal = ({text}: {text: string}) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger className="">
                    <Info className={cn(`w-4 h-4 rounded-full text-white`)} />
                </TooltipTrigger>
                <TooltipContent className="bg-white text-black">
                    <p>{text}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}